import { defineAsyncComponent, defineComponent, h } from 'vue'
import { createApp, type ModuleConfig } from '@bridge2ai/core/frontend'
import config from './config/modules.config.json'
import cities from './config/cities.json'
import './theme.css'

// Bridge newsletter admin: an overview + one "city desk" per city (issue editing, candidates, organizers).
// The public newsletter itself is server-rendered by the backend at / and /n/<city>.
const CityDesk = defineAsyncComponent(() => import('./modules/city-desk/CityDesk.vue'))

const cityModules: ModuleConfig[] = cities.map((c) => ({
  id: `city-${c.slug}`,
  moduleId: `city-${c.slug}`,
  slug: `city-${c.slug}`,
  name: c.name,
  iconUrl: '/icons/city.svg',
  componentLoader: () => defineComponent({ name: `CityDesk_${c.slug.replace(/-/g, '_')}`, render: () => h(CityDesk, { city: c.slug, cityName: c.name }) }),
}))

const customModules: ModuleConfig[] = [
  {
    id: 'newsletterOverview',
    moduleId: 'newsletter-overview',
    slug: 'overview',
    name: 'All cities',
    iconUrl: '/icons/newsletter.svg',
    componentLoader: () => defineAsyncComponent(() => import('./modules/overview/Overview.vue')),
  },
  ...cityModules,
]

createApp({
  tenantId: 'newsletter',
  config: config as any,
  customModules,
})
